import { gql } from '@apollo/client'
import { useSort } from '@btime/react-contexts'
import React from 'react'

import { stocksClient } from '../../../../../utils/apollo/api'
import { useModalData } from '../../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useStockItemOperationsState = () => React.useContext(Context) || {}
export const useStockItemOperations = () => useStockItemOperationsState()?.stockItemOperations || []

const QUERY = gql`
  query StockItemOperations($page: Int, $sort: StockItemOperationSort, $filter: StockItemOperationFilter) {
    stockItemOperations(page: $page, sort: $sort, filter: $filter) {
      id
      amount
      createdBy {
        id
        name
      }
      fromUser {
        id
        name
      }
      toUser {
        id
        name
      }
      fromPlace {
        id
        name
      }
      toPlace {
        id
        name
      }
      operationType
      insertedAt
    }
  }
`

const TransfersHistoryLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const { id } = useModalData()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: { field: field || 'INSERTED_AT', type: type || 'DESC' },
      filter: { stockItemId: id }
    },
    client: stocksClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default TransfersHistoryLoader
